export default "__VITE_ASSET__Ctdtu9Cu__"